var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"social-signin-google",attrs:{"id":"googleAuth"}},[_c('i',{staticClass:"icon-google"}),_vm._v(" Continue with Google ")])}]

export { render, staticRenderFns }